import SnackbarMaterial from "@material-ui/core/Snackbar";
import styled from "styled-components";
import { useGlobalContext } from "context/GlobalContext";

const StyledSnackbar = styled(SnackbarMaterial)`
  .MuiSnackbarContent-root {
    background: ${({ background }) => `${background} !important`};
  }
`;

export const Snackbar = () => {
  const gContext = useGlobalContext();

  let background;
  switch (gContext.dataAlert?.type) {
    case "error":
      background = "red";
      break;
    case "warning":
      background = "#a5a500";
      break;

    default:
      background = "green";
      break;
  }

  return (
    <StyledSnackbar
      open={gContext.openAlert}
      background={background}
      onClose={() => gContext.toggleAlert(null)}
      autoHideDuration={3000}
      message={gContext.dataAlert?.message}
    />
  );
};
